import { render, staticRenderFns } from "./TrainingPlanForm.vue?vue&type=template&id=48fc9fb0&scoped=true"
import script from "./TrainingPlanForm.vue?vue&type=script&lang=js"
export * from "./TrainingPlanForm.vue?vue&type=script&lang=js"
import style0 from "./TrainingPlanForm.vue?vue&type=style&index=0&id=48fc9fb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fc9fb0",
  null
  
)

export default component.exports